import { ENV, ENVIRONMENTS } from "@/constants";
import firebaseService from "./firebase.service";
import { QuizServiceBackend } from "./backend/quiz.service.backend";
import { QuizServiceMock } from "./mocks/quiz.service.mock";
import { Quiz } from "@/model/quiz.model";

export interface QuizService {
    saveQuiz(quiz: Quiz): Promise<void>;
}

const quizService = ENV == ENVIRONMENTS.DEV ? new QuizServiceMock() : new QuizServiceBackend(firebaseService);

export default quizService;